import React from "react"
import { css } from "@emotion/core"
import t from "theme"
import InternalLink from "components/UI/InternalLink"
import ExternalLink from "components/UI/ExternalLink"
import linkResolver from "../../utils/linkResolver"

const CardWrapper = ({ children, shadow = false, hover = true, hovershadow = false, ...props }) => (
    <div
        css={css`
            padding: ${shadow ? t.space[3] : 0};
            transition: transform 0.2s;
            box-shadow: ${shadow ? "0 0 0.3rem 0 " + t.color.subtlegrey : "none"};
            border-radius: ${shadow ? "4px" : "0"};
            ${hover
                ? `:hover {
                transform: ${shadow ? "translateY(-3px) scale(1.01)" : "translateY(-3px) scale(1.01)"};
                box-shadow: ${
                    hovershadow
                        ? "0 0 0.3rem 0 " + t.color.subtlegrey
                        : shadow
                        ? "0 0 0.3rem 0 " + t.color.subtlegrey
                        : "none"
                };
            }`
                : ""}
            ${hover
                ? `:active {
                transform: translateY(-1px) scale(1.01);
            }`
                : ""}
        `}
        {...props}>
        {children}
    </div>
)

const Card = ({ children, content, shadow = false, hover = true, hovershadow = false, ...props }) =>
    content ? (
        <CardWrapper shadow={shadow} hovershadow={hovershadow} hover={hover} {...props}>
            {content.type === "Internal" ? (
                <InternalLink
                    headline={content.internalLink.headline}
                    date={content.internalLink.sortTimestamp}
                    pathname={linkResolver({
                        slug: content.internalLink.slug,
                        type: content.internalLink.__typename === "ContentfulQuestion" ? "question" : "article",
                    })}
                />
            ) : (
                <ExternalLink url={content.externalLink} />
            )}
        </CardWrapper>
    ) : null

export default Card
export { CardWrapper }

/*

Generate a card that is either:
    - Quite detailed (e.g. article preview)
    - Just has headline
    - Can take care of decorations?

props include:
Decoration
Type (big, small) -> if big, big header font. if small, small header font.
Headline
Date -> if provided, show below headline
Preview-> if provided, show below headline and date
Pathname


<ContentDecoration type={articleType} company={company} date={sortTimestamp} homepage={homepage} />

*/

/*
const Card = ({ headline, shortDescription, sortTimestamp, pathname }) => {
    return (
        <div>
            <div
                css={css`
                    margin-bottom: ${t.space[6]};
                `}>
                <h2>
                    <Link to={pathname}>
                        {headline}
                    </Link>
                </h2>

                <DateLabel date={sortTimestamp} />
            </div>

            <p
                css={css`
                    color: ${t.color.lighttext};
                `}>
                {shortDescription}
            </p>
        </div>
    )
}

export default Card


const FeaturedArticlePreview = ({ slug, companies, articleType, sortTimestamp, headline, homepage }) => {
    const company = companies ? companies[0] : null

    return (
        <div>
            <ContentDecoration type={articleType} company={company} date={sortTimestamp} homepage={homepage} />

            <div>
                <Link to={linkResolver({ slug: slug, type: "article" })}>
                    {headline}
                </Link>
            </div>
        </div>
    )
}

export default FeaturedArticlePreview
*/
